import { render, staticRenderFns } from "./carDetailTransactionCar.vue?vue&type=template&id=70a31580"
import script from "./carDetailTransactionCar.vue?vue&type=script&lang=js"
export * from "./carDetailTransactionCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports